import { useState } from 'react';
import styles from './style.module.scss';
import { Row, Col, Descriptions, Spin, Typography } from 'antd';
import { ActionModal, Button, PageHeader } from 'components';
import { PlusOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import useVacancyApplications from '../useVacancyApplications';
import moment from 'moment';
import uuid from 'react-uuid';
import UIHelper from '../../../../../helpers/UIHelper';

const Single = () => {
  const { t } = useTranslation();
  const {
    singleItem,
    handleDownloadPdf,
    updateInProcess,
    handleAddWishList,
    statisticModalShow,
    setStatisticModalShow,
  } = useVacancyApplications(false);
  const vacancy_fields = singleItem?.vacancy?.vacancy_fields || [];
  const [downloadData, setDownloadData] = useState([]);
  return (
    <div>
      <PageHeader title={t('Candidati annunci')}>
        <Row gutter={16}>
          <Col>
            <Button
              type={'green'}
              big
              upperCase
              loading={updateInProcess}
              onClick={() => {
                // handleDownloadPdf(singleItem?.user?.cv?.file_name, 'cv');
                setStatisticModalShow(true);
                setDownloadData([singleItem?.user?.cv?.file_name, 'cv']);
              }}
              icon={<FilePdfOutlined />}
              disabled={!singleItem?.user?.cv?.file_name}
            >
              {t('Scarica cv')}
            </Button>
          </Col>
          <Col>
            <Button
              type={'green'}
              big
              upperCase
              loading={updateInProcess}
              onClick={() => {
                // handleDownloadPdf(singleItem?.user?.file?.file_name, 'file');
                setStatisticModalShow(true);
                setDownloadData([singleItem?.user?.file?.file_name, 'file']);
              }}
              icon={<FilePdfOutlined />}
              disabled={!singleItem?.user?.file?.file_name}
            >
              {t('Scarica allegato')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={updateInProcess}
              onClick={() => handleAddWishList(singleItem)}
              big
              upperCase
              icon={<PlusOutlined />}
              disabled={singleItem?.wishlist}
            >
              {t('Aggiungi alla wishlist')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        {singleItem ? (
          <>
            <Descriptions column={1} bordered>
              <Descriptions.Item label={t('Nome')}>
                {singleItem['users.name']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Cognome')}>
                {singleItem['users.surname']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Residenza')}>
                {singleItem['address']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Sesso')}>
                {singleItem['sex_short']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Email')}>
                {singleItem['email']}
              </Descriptions.Item>

              {/*<Descriptions.Item label={t('Outlet Village')}>*/}
              {/*  {singleItem['shopping_center.title']}*/}
              {/*</Descriptions.Item>*/}
              {/*<Descriptions.Item label={t('Insegna')}>*/}
              {/*  {singleItem['vacancies.company_id']}*/}
              {/*</Descriptions.Item>*/}
              {/*<Descriptions.Item label={t('ID Candidato')}>*/}
              {/*  {singleItem['users.id']}*/}
              {/*</Descriptions.Item>*/}
              <Descriptions.Item label={t('Fascia d’età')}>
                {singleItem['birthday_range']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Settore')}>
                {singleItem['vacancy_application_type_value']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Profilo candidato')}>
                {singleItem['vacancy_category_title']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Disponibilita` contratto')}>
                {singleItem['vacancy_type_title']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Anni esp')}>
                {singleItem['experience_years']}
              </Descriptions.Item>

              {/*<Descriptions.Item label={t('Provincia')}>*/}
              {/*  {singleItem['region']}*/}
              {/*</Descriptions.Item>*/}
              <Descriptions.Item label={t('Lingua 1')}>
                {singleItem['vacancy_language']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Livello lingua 1')}>
                {singleItem['vacancy_language_level']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Lingua 2')}>
                {singleItem['vacancy_language2']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Livello lingua 2')}>
                {singleItem['vacancy_language2_level']}
              </Descriptions.Item>
              <Descriptions.Item label={t('Data di candidatura')}>
                {moment(singleItem['created_at']).format('DD MMMM YYYY')}
              </Descriptions.Item>

              {/*<Descriptions.Item label={t('Whishlist')}>*/}
              {/*  {singleItem['wishlist'] ? 'Si' : 'No'}*/}
              {/*</Descriptions.Item>*/}
            </Descriptions>
            <br />
            <Typography.Title level={3}>
              {t('Info aggiuntive compilate dal candidato')}
            </Typography.Title>
            <Descriptions column={1} bordered>
              {vacancy_fields.map((i) => (
                <Descriptions.Item label={i.title} key={uuid()}>
                  {i.vacancy_field_answers &&
                    i.vacancy_field_answers[0] &&
                    i.vacancy_field_answers[0].value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </>
        ) : (
          <Spin size={'large'} />
        )}
      </div>
      {statisticModalShow && (
        <ActionModal
          loading={updateInProcess}
          title={t(
            'Cliccando su continua verra’ salvato il log dell’operazione',
          )}
          type={'view'}
          description={''}
          yesBtnText={t('Continua')}
          noBtnText={t('Annulla')}
          onClickOk={() => handleDownloadPdf(...downloadData)}
          onCancel={() => setStatisticModalShow(false)}
        />
      )}
    </div>
  );
};

export default Single;
